export type BrowserProduct = 'Firefox' | 'Opera' | 'IE' | 'Edge' | 'Chrome' | 'MobileChrome' | 'Safari' | 'MobileSafari' | 'Unknown';

interface UserAgentMapping {
  product: BrowserProduct;
  matcher: (userAgent: string) => boolean;
}

const USER_AGENT_MAPPINGS: UserAgentMapping[] = [
  {
    product: 'Firefox',
    matcher: userAgent => userAgent.includes('Firefox'),
  },
  {
    product: 'Opera',
    matcher: userAgent => userAgent.includes('Opera') || userAgent.includes('OPR'),
  },
  {
    product: 'IE',
    matcher: userAgent => userAgent.includes('Trident'),
  },
  {
    product: 'Edge',
    matcher: userAgent => userAgent.includes('Edge'),
  },
  {
    product: 'MobileChrome',
    matcher: userAgent => !!userAgent.match(/.*Chrome.*Mobile.*/),
  },
  {
    product: 'Chrome',
    matcher: userAgent => userAgent.includes('Chrome'),
  },
  {
    product: 'Safari',
    matcher: userAgent => !!userAgent.match(/.*Macintosh.*Safari/),
  },
  {
    product: 'MobileSafari',
    matcher: userAgent => !!userAgent.match(/.*AppleWebKit.*Mobile.*Safari/),
  },
];

export function getBrowserProduct(navigator: Navigator): BrowserProduct {
  const userAgent = navigator.userAgent;
  const mapping = USER_AGENT_MAPPINGS.find(m => m.matcher(userAgent));
  return mapping ? mapping.product : 'Unknown';
}
